import type { ConnectorDefinition } from '../../types/data-sources/define';
import { dataSourceConnectorDefinitions } from './connectors';

const mappedConnectors = Object.fromEntries(
	dataSourceConnectorDefinitions.map((connector) => [connector.id, connector]),
) as Record<string, ConnectorDefinition>;

export default mappedConnectors;
